<template>
  <div class="row q-col-gutter-x-md" style="padding:15px">
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Vehicle Value*</label>
      <q-field outlined :value="vehicleValue" :error="!isValid">
        <template #control>
          <currency-input
            @keypress.enter="validController"
            v-model="vehicleValue"
            class="q-field__input text-right abc-d"
          />
        </template>
        <template v-slot:error>Required Field.</template>
      </q-field>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Base Loss of Value*</label>
      <q-input
        outlined
        @keypress.enter="validController"
        suffix="%"
        v-model.number="lossValue"
        :rules="[
          val => (val !== null && val !== '') || 'Required Field.',
          val => (val <= 100 && val >= 0) || 'Percentage range 0-100'
        ]"
        input-class="abc-d text-right"
      />
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Damage Multiplier</label>
      <q-select outlined v-model="damage" :options="damages" input-class="abc-d text-right" />
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-xs-12">
      <label class="calculate-label">Mileage Multiplier</label>
      <q-select outlined :options="mileages" v-model="mileage" input-class="abc-d text-right" />
    </div>
    <div style="margin-top: 10px;">
      <q-btn :loading="loading" color="primary" :disable="disableController || loading" @click="calculate"
        >Calculate</q-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'DimishedValueCalculate',
  computed: {
    step: {
      get() {
        return this.$store.state.dimishedValue.step
      },
      set(val) {
        this.$store.commit('dimishedValue/SET_STEP', val)
      }
    },
    result: {
      set(val) {
        this.$store.commit('dimishedValue/SET_RESULT', val)
      },
      get() {
        return this.$store.state.dimishedValue.result
      }
    },
    show: {
      set(val) {
        this.$store.commit('dimishedValue/SET_SHOW', val)
      },
      get() {
        return this.$store.state.dimishedValue.show
      }
    },
    disableController() {
      return !(
        this.vehicleValue &&
        this.lossValue >= 0 &&
        this.lossValue <= 100 &&
        this.lossValue !== '' &&
        this.damage >= 0 &&
        this.damage <= 1 &&
        this.mileage <= 1 &&
        this.mileage >= 0
      )
    },
    isValid() {
      return this.vehicleValue
    }
  },
  methods: {
    validController() {
      !this.disableController ? this.calculate() : ''
    },
    calculate() {
      this.loading = true
      this.show = false
      setTimeout(() => {
        const res = (((this.lossValue / 100) * this.vehicleValue * this.damage) / 100) * this.mileage * 100
        this.result = res.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })
        this.show = true
        this.loading = false
      }, 2000)
    }
  },
  data() {
    return {
      loading: false,
      vehicleValue: 2000,
      lossValue: 10,
      damages: [1.0, 0.75, 0.5, 0.25, 0.0],
      mileages: [1.0, 0.8, 0.6, 0.4, 0.2, 0.0],
      damage: 1.0,
      mileage: 1.0
    }
  }
}
</script>

<style scoped></style>
